import { FC, ReactNode, useEffect } from "react";
import * as Sentry from "@sentry/react";
import { API_URL } from "..";
import {
  FetchBaseQueryError,
  FetchBaseQueryMeta,
  QueryReturnValue,
} from "@reduxjs/toolkit/query";

interface SentryProviderProps {
  children: ReactNode;
}

export const SENTRY_DSN: string = import.meta.env.VITE_SENTRY_DSN_DATING;
export const SENTRY_ENABLE: string = import.meta.env.VITE_SENTRY_ENABLE_DATING;

export const CheckSentryEnable = () => {
  if (!SENTRY_DSN || !SENTRY_ENABLE || SENTRY_ENABLE !== "true") return false;
  return true;
};

export const SetSentryUser = (tg_id: number) => {
  Sentry.setUser({
    id: tg_id,
    ip_address: "{{auto}}",
  });
};

export const CheckSentryExceptionsStatusCodes = (
  response: QueryReturnValue<unknown, FetchBaseQueryError, FetchBaseQueryMeta>
): boolean => {
  if (
    response.error &&
    response.error.status != 401 &&
    response.error.status != 403 &&
    response.error.status != 409 &&
    response.error.status != 418
  )
    return true;
  return false;
};

export const SentryProvider: FC<SentryProviderProps> = ({ children }) => {
  useEffect(() => {
    if (!CheckSentryEnable()) return;

    const sentryCfg = {
      dsn: SENTRY_DSN,
      integrations: [Sentry.browserTracingIntegration()],
      tracePropagationTargets: ["localhost", /^\//, API_URL],
      normalizeDepth: 10,
      tracesSampleRate: 1.0,
      sendDefaultPii: true,
    };

    Sentry.init(sentryCfg);
  }, []);

  return <>{children}</>;
};
